export class UserTab {
    user: any;
    heading:String;
    active: boolean;
    
  }